import React from 'react';
import { selectAmountPariL, selectAmountPariP, selectEmail, selectIdBank, selectInsuranceCompanyLife, selectInsuranceCompanyProperty, selectListCompaniesLife, selectListCompaniesProperty, selectPhone, selectRatePariL, selectRatePariP, selectTarifs, setIdPoliceL, setIdPoliceP, setIsLoadPari, setLinkPayPari, setLinkRedirectPary, setNumPolicyPari, setPolicyIdLife, setPolicyIdProp, setProcessCalc, setShowChangeField, setStepCalc, setSumFinalL, setSumFinalP, setWaitFinalCalc } from "./calcSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectCookie, selectLifeOption, selectMortgageBalance, selectPropertyOption, selectToken, selectTokenVsk } from '../precalc/precalcSlice';
import { selectBirthDate, selectIssueDate, selectIssuedBy, selectLastname, selectName, selectPatronymic, selectRegAdr, selectSerial, selectSex, selectSubdivision } from './personSlice';
import { createContractPari, finalCreatePolicies } from './calcApi'
import { selectAddresObject, selectKlAdrHolderReg, selectKlAdrObj, selectYearBuild } from './objectSlice';
import { selectDateBegin, selectDateContract, selectNumberContract } from './contractSlice';
import { setShowPopUpManager } from '../home/homeSlice';

const NextBtn = (props) => {

    const dispatch = useDispatch();

    const idBank = useSelector(selectIdBank)
    const lifeOption = useSelector(selectLifeOption)
    const propertyOption = useSelector(selectPropertyOption)
    const insuranceCompanyProperty = useSelector(selectInsuranceCompanyProperty)
    const insuranceCompanyLife = useSelector(selectInsuranceCompanyLife)
    const token = useSelector(selectToken)
    const token_vsk = useSelector(selectTokenVsk)
    const cookie = useSelector(selectCookie)

    const name = useSelector(selectName)
    const lastname = useSelector(selectLastname)
    const patronymic = useSelector(selectPatronymic)

    const email = useSelector(selectEmail)
    const phone = useSelector(selectPhone)


    const serial = useSelector(selectSerial)
    const subdivision = useSelector(selectSubdivision)
    const issuedBy = useSelector(selectIssuedBy)
    const issueDate = useSelector(selectIssueDate)


    const mortgageBalance = useSelector(selectMortgageBalance)

    const birthday = useSelector(selectBirthDate)
    const sex = useSelector(selectSex)
    const kladr_holder_reg = useSelector(selectKlAdrHolderReg)
    const kladr_object = useSelector(selectKlAdrObj)
    const addres_holder_reg = useSelector(selectRegAdr)
    const addres_object = useSelector(selectAddresObject)

    const numberContract = useSelector(selectNumberContract)
    const dateContract = useSelector(selectDateContract)
    const dateBegin = useSelector(selectDateBegin)
    const yearBuild = useSelector(selectYearBuild)

    const amoun_pari_p = useSelector(selectAmountPariP)
    const amoun_pari_l = useSelector(selectAmountPariL)

    const rate_pari_l = useSelector(selectRatePariL)
    const rate_pari_p = useSelector(selectRatePariP)

    const tarifs = useSelector(selectTarifs)

    const list_companies_property = useSelector(selectListCompaniesProperty)
    const list_companies_life = useSelector(selectListCompaniesLife)
    

    const handleClickNext = async () => {
        dispatch(setIdPoliceL(''))
        dispatch(setIdPoliceP(''))
        if (!props.showAllFields) {
            props.handleFind()
            return
        }
        console.log('handleClickNext', props.check)
        if (!props.checkFields()) return

        if (!props.checkConfirm) {
            props.setShowAlertForUser(true)
            return
        }

        dispatch(setShowChangeField(false))
        
        if (props.check) {
            dispatch(setShowPopUpManager(true))
            return
        }
        
        window.ym(90426649,'reachGoal','obyekt_ok')
        dispatch(setStepCalc('buy'))
        dispatch(setProcessCalc('buy'))
        const unique_id = Math.random().toString(36).slice(2)
        const is_two_polices = lifeOption && propertyOption
        const params = {
            id_bank: idBank,
            token: token,
            token_vsk: token_vsk,
            cookie: cookie,
            is_two_polices: is_two_polices,
            // company1: insuranceCompany === 'Зетта Страхование' ? 'zetta' : insuranceCompany === 'Абсолют' ? 'absolute' : 'vsk',
            company1: insuranceCompanyProperty,
            // company2: insuranceCompany2 === 'Зетта Страхование' ? 'zetta' : insuranceCompany2 === 'Абсолют' ? 'absolute' : 'vsk',
            company2: insuranceCompanyLife,
            lastname: lastname,
            firstname: name,
            parentname: patronymic,
            birthday: birthday,//birthDate,
            sex: 'М', //sex,
            addres_holder_reg: addres_holder_reg, //'г Москва, пр-кт Мира, д 119 стр 67, кв 7'
            limit_sum: mortgageBalance,
            agr_credit_number: numberContract, //agr_credit_number,
            agr_credit_date_conc: dateContract ? dateContract.toLocaleDateString().split('.').reverse().join('-') : '',//date_credit ? date_credit.toLocaleDateString().split('.').reverse().join('-') : '',
            // agr_credit_date_conc: date_credit,
            dateBegin: dateBegin.toLocaleDateString().split('.').reverse().join('-'),//dateBegin ? dateBegin.toLocaleDateString().split('.').reverse().join('-') : '',

            addres_object:  addres_object, // 'г Москва, пр-кт Мира, д 119 стр 67, кв 7',
            year_build: yearBuild,//yearh_build,

            issue_date: issueDate, //new Date('2020-01-01'),
            issue_by: issuedBy,
            series_doc: serial.split(' ')[0],
            number_doc: serial.split(' ')[1],
            div_code: subdivision,

            email: email,
            phone: phone.replace(/\D/g, ''),
            is_credit: 0,
            unique_id: unique_id
        }

        dispatch(setWaitFinalCalc(true))
        const { isn, isn2, premium_sum_final, premium_sum_final2, policy_id_prop, policy_id_life, res_error_life, res_error_prop } =
            await finalCreatePolicies(
                params,
                lifeOption, //&& (insuranceCompanyLife !== 'pari'), 
                propertyOption, //&& (insuranceCompanyProperty !== 'pari'), 
                idBank
            )
        console.log('policies ids', policy_id_prop, policy_id_life)
        dispatch(setPolicyIdProp(policy_id_prop))
        dispatch(setPolicyIdLife(policy_id_life))

        if (res_error_life === 'phone') dispatch(setShowChangeField(true))

        if (unique_id && (insuranceCompanyProperty === 'pari' || insuranceCompanyLife === 'pari')) handleBuyPari(unique_id)
        else dispatch(setWaitFinalCalc(false))
        
        
        if (res_error_life === 'err' && insuranceCompanyLife !== 'pari') {
            dispatch(setIdPoliceL('manager'))
            console.log('setIdPoliceL manager')
        }
        else if (insuranceCompanyLife !== 'pari') dispatch(setIdPoliceL(isn2 || '0'))
        if (res_error_prop === 'err' && insuranceCompanyProperty !== 'pari') {
            dispatch(setIdPoliceP('manager'))
            console.log('setIdPoliceP manager')
        }
        else if (insuranceCompanyProperty !== 'pari') dispatch(setIdPoliceP(isn || '0'))

        dispatch(setSumFinalP(premium_sum_final))
        dispatch(setSumFinalL(premium_sum_final2))
        
    }

    const handleBuyPari = (unique_id) => {

        dispatch(setIsLoadPari(true))
        console.log('handleBuyPari', kladr_holder_reg, kladr_object)
        const params = {
            id_bank: idBank,
            lastname: lastname,
            firstname: name,
            parentname: patronymic,
            birthday: birthday,
            sex: sex,
            addres_holder_reg: addres_holder_reg,
            kladr_holder_reg: kladr_holder_reg,
            limit_sum: mortgageBalance,

            agr_credit_number: '890', //agr_credit_number,
            agr_credit_date_conc: '', //date_credit ? date_credit.toLocaleDateString().split('.').reverse().join('-') : '',
            dateBegin: new Date('2024-10-03').toLocaleDateString().split('.').reverse().join('-'),//dateBegin ? dateBegin.toLocaleDateString().split('.').reverse().join('-') : '',

            addres_object: addres_object,
            kladr_object: kladr_object,
            yearh_build: 2020, // yearh_build,

            issue_date: new Date('2020-01-01'),//issue_date,
            issue_by: issuedBy,
            series_doc: serial.split(' ')[0],
            number_doc: serial.split(' ')[1],
            div_code: subdivision,

            email: 'senik1809@gmail.com',
            phone: '+79094050778',

            // pari
            amount_p: insuranceCompanyProperty === 'pari' && propertyOption ? list_companies_property.find((e) => e.company === 'ПАРИ').premium : 0,
            amount_l: insuranceCompanyLife === 'pari' && lifeOption ? list_companies_life.find((e) => e.company === 'ПАРИ').premium : 0,

            amoun_pari_p: amoun_pari_p,
            amoun_pari_l: amoun_pari_l,

            rate_pari_p: rate_pari_p,
            rate_pari_l: rate_pari_l,

            tarifs: tarifs,
            unique_id: unique_id,
        }
        createContractPari(params, (data) => {
            console.log('createContractPari', data)
            // setIsBuyPari(true)
            dispatch(setIsLoadPari(false))

            if (data.res) {
                dispatch(setNumPolicyPari(data.contract.CreateInsuranceContractResult['a:Data']['b:Contract']['b:Id']))
                console.log('pari create', data.contract.CreateInsuranceContractResult['a:Data']['b:Contract']['b:Id'])

                dispatch(setLinkPayPari(data.res.redirect))
                dispatch(setLinkRedirectPary(data.res.redirect))
                // setShowPayPariWindow(true)
                if (insuranceCompanyProperty === 'pari') 
                    dispatch(setSumFinalP(list_companies_property.find((e) => e.company === 'ПАРИ').premium))
                else 
                    dispatch(setSumFinalL((list_companies_life.find((e) => e.company === 'ПАРИ')?.premium)))
            }
            else {
                console.log('no data res')
                if (insuranceCompanyProperty === 'pari') dispatch(setIdPoliceP('manager'))
                else dispatch(setIdPoliceP(''))
                if (insuranceCompanyLife === 'pari') dispatch(setIdPoliceL('manager'))
                else dispatch(setIdPoliceL(''))
            }
            dispatch(setWaitFinalCalc(false))
        })
    }


    const checkCheckBoxes = (checkOne, checkTwo, checkThree, checkFour) => {
        if (checkOne === true && checkTwo === true && checkThree === true && checkFour === true) {
            console.log("да")
            return true
        } else {
            console.log("нет")
            return false
        }
    }

    const handleClickDissableNext = () => {
        props.setShowAlertForUser(true)
    }

    return (
        <>
            
                <div type="submit" className="button button-1 button-novostroiki-1 button-step-23"
                    id="button-step-23" value="Далее"
                    onClick={handleClickNext}
                >
                    {props.text}
                </div>
            
        </>
    );
};

export default NextBtn;